import { BASE_LOCALE } from "../locale.ts";
import type { Locale } from "../locale.ts";
import type { RowPreview } from "../products/rows.ts";
import { BANDS, placements } from "./bands.ts";
import type { Fit, Hero, ShotName } from "./bands.ts";
import { HEIGHTS, WIDTHS } from "./manifest.ts";

export interface ShotSource {
  readonly from: number;
  readonly width: number;
  readonly height: number;
  readonly path: string;
  readonly webp2x?: true;
}

interface Placed {
  readonly from: number;
  readonly width: number | undefined;
}

const sized = (
  wanted: Locale,
  name: ShotName,
  placed: readonly Placed[],
): readonly ShotSource[] => {
  const locale = HEIGHTS[wanted] === undefined ? BASE_LOCALE : wanted;
  return placed.flatMap(({ from, width }) => {
    const height = width === undefined ? undefined : HEIGHTS[locale]?.[`${name}.${width}`];
    return width === undefined || height === undefined
      ? []
      : [{ from, width, height, path: `/shots/${locale}/${name}.${width}` }];
  });
};

const widthsOf = (shelf: keyof typeof WIDTHS): readonly number[] => WIDTHS[shelf];

export const rowSources = (locale: Locale, preview: RowPreview, fit: Fit): readonly ShotSource[] =>
  sized(
    locale,
    preview,
    placements(fit).map(({ shelf, index, band }) => ({
      from: band.from,
      width: widthsOf(shelf)[index],
    })),
  ).map((source) => (fit === "menu" ? { ...source, webp2x: true } : source));

export const heroSources = (locale: Locale, hero: Hero): readonly ShotSource[] =>
  sized(
    locale,
    `hero-${hero}`,
    BANDS.hero.map((band, index) => ({ from: band.from, width: widthsOf("hero")[index] })),
  );
